import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationComponent } from './organization.component';
import { OrganizationListComponent } from './organization-list/organization-list.component';
import { organizationRoutingModule } from './organization-routing.module';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { SideNavigationComponent } from './side-navigation/side-navigation.component';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { CreateOrganizationComponent } from './organization-list/create-organization/create-organization.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { OrganizationDetailComponent } from './organization-list/organization-detail/organization-detail.component';
import { OrganizationsService } from './services/organizationService/organization.service';
import { ApiEndPointsOrganizations } from './common/apiUrls/api-end-points-organization';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from 'src/app/middleware/authentication/interceptor/auth-interceptor';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatExpansionModule } from '@angular/material/expansion';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxMatDrpModule } from 'ngx-mat-daterange-picker';
import { MatMenuModule } from '@angular/material/menu';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatRadioModule } from '@angular/material/radio';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSortModule } from '@angular/material/sort';
import { MatBadgeModule } from '@angular/material/badge';
import { RouterModule } from '@angular/router';
import { CreateUserComponent } from './organization-list/create-user/create-user.component';
import { UserService } from '../admin/users/services/user/user.service';
import { ApiEndPointsUser } from '../admin/users/common/apiUrls/api-end-points';
import { RoleService } from '../admin/roless/services/role.service';
import { ApiEndPointsRoles } from '../admin/roless/apiURLs/api-end-points';
import { PaginationViewModel } from 'src/app/viewModels/permissions/paginationViewModel/pagination-view-model';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MultiselectVM } from 'src/app/viewModels/common/multiselect-vm';
import { CreateUserOrgComponent } from './organization-list/create-userOrg/create-userOrg.component';
//import { ImageCropperModule } from 'ngx-image-cropper';
//import { ImageCropperComponent } from './organization-list/organization-detail/component/image-cropper.component';
import { ImageCropperModule } from './organization-list/lib/image-cropper.module';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { CKEditorModule } from 'ckeditor4-angular';
import { NgxMaskModule, IConfig } from 'ngx-mask';
//import { ImageCropperModule } from 'ngx-image-cropper';
//import { ImageCropperModule } from './cropper.module';
//import { ImageCropperModule } from 'ngx-image-cropper';
const maskConfig: Partial<IConfig> = {
  validation: false,
};
@NgModule({
  declarations: [OrganizationComponent, OrganizationListComponent, SideNavigationComponent, CreateOrganizationComponent, OrganizationDetailComponent
  ,CreateUserComponent,CreateUserOrgComponent],
  imports: [
    CommonModule,
    organizationRoutingModule,
    MatDialogModule,
    FormsModule,
    MatCardModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,   
    MatProgressSpinnerModule,
    MatSlideToggleModule,   
    MatDatepickerModule,
    NgxDaterangepickerMd,  
    MatRadioModule,
    MatChipsModule,
    HttpClientModule,
    RouterModule,
    MatPaginatorModule,   
    MatTooltipModule,
    MatSortModule,
    MatBadgeModule,  
    FlexLayoutModule,
    MatMenuModule,  
    NgxMatDrpModule,   
    MatAutocompleteModule,   
    ScrollingModule,     
    MatExpansionModule,
    MatSliderModule,
    MatButtonToggleModule,  
    MatListModule,
    MatCheckboxModule,
    FormsModule,
    MatTabsModule,
    ImageCropperModule,
    CKEditorModule,
    NgxMaskModule.forRoot(maskConfig),
    //ImageCropperModule,
    //ImageCropperComponent,
    //ImageCropperModule,
   // ImageCropperModule,
    NgMultiSelectDropDownModule.forRoot()
  ],

  providers: [   
   // == Organization == //
   OrganizationsService,
   ApiEndPointsOrganizations, 
   PaginationViewModel,
   UserService,
   ApiEndPointsUser,
   
   RoleService,
   ApiEndPointsRoles,
   MultiselectVM,
   LoaderService,
   {provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true},  
  ], 
 
})
export class OrganizationModule { }
